// All analytics events must go through this file. Pages should not import analytics directly.
import activityData from "../data/private/activity.json";
import { trackEvent } from "./analytics";

const ACTIVITY_KEY = "myv_activity";
const PROGRESS_KEY = "myv_progress";
const DEDUPE_KEY = "myv_activity_dedupe";

const readJson = (key, fallback) => {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch (error) {
    return fallback;
  }
};

const writeJson = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    // no-op
  }
};

export const getActivities = () => readJson(ACTIVITY_KEY, []);

export const getActivityConfig = () =>
  activityData.items.reduce((acc, item) => {
    acc[item.type] = item;
    return acc;
  }, {});

export const logActivity = (type, meta = {}) => {
  const dedupeKey = `${type}:${JSON.stringify(meta)}`;
  let dedupeMap = {};
  try {
    const raw = sessionStorage.getItem(DEDUPE_KEY);
    dedupeMap = raw ? JSON.parse(raw) : {};
  } catch (error) {
    dedupeMap = {};
  }
  if (dedupeMap[dedupeKey]) {
    return;
  }
  dedupeMap[dedupeKey] = true;
  try {
    sessionStorage.setItem(DEDUPE_KEY, JSON.stringify(dedupeMap));
  } catch (error) {
    // no-op
  }

  const config = getActivityConfig()[type];
  trackEvent(type, meta);
  if (!config) return;
  const entry = {
    type,
    icon: config.icon,
    label: config.label,
    timestamp: new Date().toISOString(),
    meta,
  };
  const activities = getActivities();
  const next = [entry, ...activities].slice(0, 20);
  writeJson(ACTIVITY_KEY, next);
  trackEvent("activity_logged", { type });
};

export const getProgress = () => readJson(PROGRESS_KEY, {});

export const completeProgressStep = (key) => {
  const progress = getProgress();
  if (progress[key]) return;
  const next = { ...progress, [key]: true };
  writeJson(PROGRESS_KEY, next);
  trackEvent("progress_step_completed", { key });
};
